import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuPackagedAmountView } from "src/tenantCustomizations/tenants/mellano/views/luukku/metrics/MellanoLuukkuPackagedAmountView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/packagedAmount")({
	staticData: { title: "Paketoitu määrä", legacyViewKey: "mellanoLuukkuPackagedAmountView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuPackagedAmountView />;
}
